import React from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'
import classNames from 'classnames'
import PhoneInput from 'react-phone-number-input/input'
import Modal from 'react-modal'
import Loading from 'react-loading-animation'

import CountrySelect from './PhoneCountrySelect'

class CartPhone extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      showModal: false,
      loading: false,
      phoneValidated: false,
      submitting: false,
      errors: {},
      country: 'IT',
    }
  }

  componentDidMount() {
    window.scrollTo(0, 0)
    const { disableAuth, updateCart } = this.props

    if (disableAuth) {
      updateCart({ step: 'infos' })
    }
  }

  onSubmit(e) {
    e.preventDefault()
    const { cellarId, cart, updateCart, authenticationRequest } = this.props
    const { phoneValidated } = this.state

    this.setState({ loading: true, submitting: true })
    authenticationRequest(
      cellarId,
      phoneValidated ? 'confirm' : 'request',
      cart.data
    ).then((response) => {
      if (!phoneValidated) {
        this.setState({ phoneValidated: true, loading: false, submitting: false })
      } else {
        updateCart({
          step: 'infos',
          data: response,
        })
      }
    }).catch(() => {
      if (phoneValidated) {
        this.setState({ errors: { code: 'Invalid verification code' } })
      } else {
        this.setState({ errors: { phone: 'Invalid phone number' } })
      }
      this.setState({ loading: false, submitting: false })
    })
  }

  openModal(e) {
    e.preventDefault()
    this.setState({ showModal: true })
  }

  closeModal() {
    this.setState({ showModal: false })
  }

  renderField(field, translationId, type = 'text') {
    const { cart, updateCart } = this.props
    const { errors } = this.state
    const error = errors[field]

    return (
      <div
        className={
          classNames('form__field', {
            'form__field--invalid': error,
          })}
      >
        <label className="form__label">
          <FormattedMessage id={translationId} />
        </label>
        <input
          type={type}
          className="form__input"
          value={cart.data[field]}
          onChange={(e) => updateCart({ data: { [field]: e.target.value } })}
        />
        {error && <div className="form__error">{error}</div>}
      </div>
    )
  }

  render() {
    const {
      cart,
      updateCart,
      paymentInfo,
      disableAuth,
    } = this.props
    const translationId = `app.cart.step.${cart.step}.title`
    const { loading, phoneValidated, submitting } = this.state

    if (disableAuth) {
      return null
    }

    return (
      <div className="reservation-step">
        <h1 className="reservation-step__title">
          <FormattedMessage id={translationId} />
          {/* <a href="#" onClick={this.openModal.bind(this)}>
          <i className="icon--info"></i>
        </a> */}
        </h1>
        <div className="reservation-step__content">
          <form className="form" onSubmit={this.onSubmit.bind(this)}>
            <div className="grid">
              <div className="grid__item lap-6-12 space--bottom-1">
                <Loading isLoading={loading}>
                  {
                    phoneValidated ? (
                      <div>
                        { this.renderField('code', 'app.cart.step.auth.fields.code', 'tel') }
                        <p className="space--both-1 smallprint">
                          <FormattedMessage id="app.cart.step.auth.fields.code.info" />
                        </p>
                      </div>
                    )
                      :
                      <div>
                        <label className="form__label">
                          <FormattedMessage id="app.cart.step.auth.fields.phone" />
                        </label>
                        <CountrySelect
                          className="form__input space--bottom-1"
                          locale={cart.data.ui_language}
                          value={this.state.country}
                          onChange={(country) => this.setState({ country })}
                        />
                        <PhoneInput
                          className="form__input space--bottom-1"
                          onChange={(phone) => updateCart({ data: { phone } })}
                          country={this.state.country}
                          international
                          withCountryCallingCode
                          value={cart.data.phone}
                          placeholder="e.g. 636 555 0113"
                          required
                        />
                        { cart.data.phone && this.state.errors.phone &&
                    <div className="form__error">Invalid phone</div>
                        }
                        <p className="space--both-1 smallprint">
                          <FormattedMessage id="app.cart.step.auth.fields.phone.info" />
                        </p>
                      </div>
                  }
                </Loading>
              </div>
              <div className="grid__item lap-6-12">
                { paymentInfo }
              </div>
              <div className="grid__item form__actions">
                <button
                  type="submit"
                  disabled={submitting}
                  className="button--primary button--large"
                >
                  <FormattedMessage id="app.cart.next" />
                </button>
              </div>
            </div>
            <Modal
              isOpen={this.state.showModal}
              onRequestClose={this.closeModal.bind(this)}
            >
              { paymentInfo }
            </Modal>
          </form>
        </div>
      </div>
    )
  }
}

CartPhone.propTypes = {
  cart: PropTypes.object.isRequired,
  cellarId: PropTypes.string,
  updateCart: PropTypes.func.isRequired,
  paymentInfo: PropTypes.object.isRequired,
  authenticationRequest: PropTypes.func.isRequired,
  disableAuth: PropTypes.bool,
}

export default CartPhone
